export enum CheckboxState {
  CHECKED = 'CHECKED',
  INDETERMINATE = 'INDETERMINATE',
  UNCHECKED = 'UNCHECKED',
}

export type CheckboxStateType = `${CheckboxState}`;

export interface CheckboxData {
  name: string;
  children?: CheckboxData[];
}
